module.exports = __webpack_public_path__ + "img/375.0c397994.jpg";